import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import { Link } from 'react-router-dom';

function Main({ activeIndex }) {
    return (
        <Tab.Container id="list-group-tabs-example" defaultActiveKey="#link1">
            <Row>
                <Col sm={12}>

                    <ListGroup>

                        <ListGroup.Item as={Link} action to="/admissions" className="mb-3 p-3">
                            {/* <i className="fas fa-chevron-circle-right me-3"></i> 
                            <img className='ms-1' src="https://files.iittp.ac.in/images/demo/iit/Other/new.gif" width="36" height="20" />
                            */}
                            <b>Programs</b>
                        </ListGroup.Item>
                    </ListGroup>

                    <ListGroup>

                    <ListGroup.Item as={Link} action to="/m-tech-international" className={`p-3 ${activeIndex == 7 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            M.Tech International   
                        </ListGroup.Item>

                        <ListGroup.Item as={Link} action to="/ms-phd-international" className={`p-3 ${activeIndex == 6 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            M.S./Ph.D. International    
                        </ListGroup.Item>


                        <ListGroup.Item as={Link} action to="/ph-d-admission" className={`p-3 ${activeIndex == 0 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Ph.D.  
                        </ListGroup.Item>

                        <ListGroup.Item as={Link} action to="/ms-admission" className={`p-3 ${activeIndex == 1 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            M.S. (Research)  
                        </ListGroup.Item>

                        {/* need to check
                        <img className='ms-1' src="https://files.iittp.ac.in/images/demo/iit/Other/new.gif" width="36" height="20" /> 
                        */}
                        <ListGroup.Item as={Link} action to="/m-tech-admission" className={`p-3 ${activeIndex == 2 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            M.Tech.  
                        </ListGroup.Item>

                        {/*Need to check  */}
                        <ListGroup.Item as={Link} action to="/master-of-public-policy-mpp-admission" className={`p-3 ${activeIndex == 4 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Master of Public Policy 
                        </ListGroup.Item>

                        <ListGroup.Item as={Link} action to="/m-sc-admission" className={`p-3 ${activeIndex == 3 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            M.Sc.
                        </ListGroup.Item>



                        <ListGroup.Item as={Link} action to="/b-tech-admission" className={`p-3 ${activeIndex == 5 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            B.Tech
                        </ListGroup.Item>

               



                       

                    </ListGroup>
                </Col>
                {/* <Col sm={8}>
          <Tab.Content>
            <Tab.Pane eventKey="#link1">Tab pane content 1</Tab.Pane>
            <Tab.Pane eventKey="#link2">Tab pane content 2</Tab.Pane>
          </Tab.Content>
        </Col> */}
            </Row>
        </Tab.Container>
    );
}

export default Main;

